import { Button } from "@/components/ui/baseUi/button"
import { cn } from "@/modules/lib/utils"
import ChatEmpty from "@images/empty/chat_empty.svg"
import { useChatPageContext } from "@modules/chat/contexts/chatPageContext"
import { word } from "@modules/core/utils/i18n"
import { EmptyView } from "@modules/ui/components/emptyView"
import { UserPlusIcon, UsersIcon } from "lucide-react"

type EmptyChannelProps = {
  className?: string
} & React.ComponentProps<"div">

export function EmptyChannel({ className, ...props }: EmptyChannelProps) {
  const { updateIsCreatingNewChannel, updateIsCreatingGroup } = useChatPageContext()

  const openOneToOneChannelCreation = () => {
    updateIsCreatingGroup(false)
    updateIsCreatingNewChannel(true)
  }
  const openGroupChannelCreation = () => {
    updateIsCreatingGroup(true)
    updateIsCreatingNewChannel(true)
  }

  return (
    <div className={cn("flex flex-1 flex-col items-center justify-center gap-2", className)} {...props}>
      <EmptyView
        flexGrow={true}
        image={{ src: ChatEmpty, background: "var(--neutral-100)", padding: "2rem 4rem" }}
        description={word("chat.channel.empty.description")}
      />

      <div className="flex w-full items-center justify-center gap-3 overflow-hidden pt-2 pr-3 pb-1 pl-3">
        <Button variant="outline" size="sm" onClick={openGroupChannelCreation} className="h-12 w-12">
          <UsersIcon color="currentColor" />
        </Button>
        <Button variant="outline" size="sm" onClick={openOneToOneChannelCreation} className="h-12 w-12">
          <UserPlusIcon color="currentColor" />
        </Button>
      </div>
    </div>
  )
}
